import { ISetDrawerRef } from '../../../actions/search/setDrawerRef'
import { ISearchStore } from '../index'

export default function(store: ISearchStore, action: ISetDrawerRef) {
  return {
    ...store,
    drawerRef: action.ref,
  }
}
